module.exports = __webpack_public_path__ + "static/media/26.b38114d9.jpg";